module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_troendelag_neg.2f79bb82.png";